import { Component, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { ROUTES } from 'src/app/route/routes';
import { MdrRequestHistoryComponent } from '../mdr-request-history/mdr-request-history.component';

const HISTORY_TAB_INDEX = 1;

@Component({
  selector: 'app-mdr-dashboard',
  templateUrl: './mdr-dashboard.component.html',
  styleUrls: ['./mdr-dashboard.component.scss'],
  standalone: false,
})
export class MdrDashboardComponent {

  @ViewChild(MdrRequestHistoryComponent) historyComponent?: MdrRequestHistoryComponent;

  constructor(private router: Router) {}

  /**
   * The two tabs own independent stores. Actions taken in the "manage" tab
   * (accept/reject) don't propagate to the already-loaded history store, so
   * we refresh the history every time the user (re)enters its tab. The very
   * first entry is handled by the component's own ngOnInit — at that point
   * `historyComponent` isn't created yet, so we skip the redundant reload.
   */
  onTabChange(index: number): void {
    if (index === HISTORY_TAB_INDEX) {
      this.historyComponent?.reload();
    }
  }

  goHome(): void {
    this.router.navigate([ROUTES.HOME.path]);
  }
}
